import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import ToDoLink from './ToDoLink';
import { Link } from "react-router-dom";


class ToDos extends Component {
    constructor() {
        super();
        this.state = {
            list: [
                { id: 1, name: "todo1" },
                { id: 2, name: "todo2" },
                { id: 3, name: "todo3" }
            ]
        }
    }


    render() {
        const todoList = this.state.list.map(name => {
            return (
                <div >
                <table className="table">
                    <tr>
                        <td>{name.id}</td>
                        <td>{name.name}</td>
                        <td><Link to={'./ToDoLink/${name.id}'}> details par objet </Link></td>
                    </tr>
                </table>
                </div>
            );
        })
        return (
           <div>
                {todoList}
           </div>

        );
    }
}

export default ToDos;
